/* @flow */
import * as React from 'react';
import PropTypes from 'prop-types';
import { inject, observer } from 'mobx-react';
import { observable } from 'mobx';
import { translate } from 'react-i18next';

//----------------------------------------------------------------------//
// LOCAL IMPORTS
//----------------------------------------------------------------------//
import styles from './DetailsPanel.module.scss';
import AssetsDisplay from 'views/NotificationsReview/components/AssetsDisplay/AssetsDisplay';
import { HeadMessage } from '../../../SentRequestsReview/components/HeadMessage/HeadMessage';
import { PoNumber } from '../../../SentRequestsReview/components/PoNumber/PoNumber';
import { ContractDetails } from '../../../SentRequestsReview/components/ContractDetails/ContractDetails';

@translate()
export default class DetailsPanel extends React.Component<*> {
  render(): React.Element<*> {
    const { data } = this.props;
    const contract = data.contract || (data.details && data.details.contract);

    const reason =
      data.reason ||
      (data.details && data.details.reason) ||
      (data.template_values && data.template_values.reason);
    const new_po_number =
      data.new_po_number ||
      (data.details && data.details.new_po_number) ||
      (data.template_values && data.template_values.new_po_number);

    let assets = (contract && contract.assets) || null;

    return (
      <div className={styles['details-panel']}>
        <div className={styles['container']}>
          {data.action_name && <HeadMessage data={this.props.data} />}

          {contract && <ContractDetails contract={contract} />}

          {assets && (
            <AssetsDisplay assets={assets} reason={reason} title={this.props.assetTitle} />
          )}

          {new_po_number && <PoNumber new_po_number={new_po_number} />}
        </div>
      </div>
    );
  }
}

DetailsPanel.propTypes = {
  data: PropTypes.object.isRequired,
  t: PropTypes.func,
};
